export function getSourceStatus ({ enabled }, hasRecentlySentData, isThirdParty) {
  if (!enabled && isThirdParty) return 'disabled'
  if (hasRecentlySentData === false) return 'no-recent-data'
  return 'enabled'
}

export function getSourceMetadataType ({ category, categories, name }) {
  const isCloudApp = category === 'cloud apps'
  return isCloudApp
    ? `${categories[0]} Cloud App`
    : `${name} ${category}`
}



// WEBPACK FOOTER //
// ./lib/utils/sources.js